import React from "react";
import { Typography } from "@mui/material";

const ManageBuyers = () => {
  return (
    <>
      <Typography variant="h5" gutterBottom>
        Manage Buyers
      </Typography>
      <Typography>
        Here you can add, remove, and manage buyers for your account.
      </Typography>
    </>
  );
};

export default ManageBuyers;
